/*
 * @Author: wangqi angelqiqiwang@shjinjia.com.cn
 * @Date: 2024-01-31 13:45:39
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-01-31 13:56:12
 * @FilePath: \oak\src\store\modules\routerMap\views\repertory.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 库存管理
const map = {
  logisticsClaims: () => import('@/views/repertory/LogisticsClaims'), // 物流赔付导入
  freightBill: () => import('@/views/repertory/FreightBill'), // 运费账单导入
  freightBillManagement: () =>
    import('@/views/repertory/FreightBillManagement'), // 运费账单
  freightReconciliation: () =>
    import('@/views/repertory/FreightReconciliation'), // 运费对账列表
  freightSettlement: () => import('@/views/repertory/FreightSettlement'), // 运费结算账单
  settlementParameter: () => import('@/views/repertory/SettlementParameter'), // 结算参数配置
  freightAbnormal: () => import('@/views/repertory/FreightAbnormal'), // 运费结算异常
  logisticsClaimsDetail: () =>
    import('@/views/repertory/LogisticsClaimsDetail'), // 物流赔付导入明细
  weightBillVerify: () => import('@/views/repertory/WeightBillVerify'), // 账单重量核验
  freightApprovalTableList: () => import('@/views/repertory/FreightApproval/FreightApprovalTableList'), // 运费审批
  createFreightApproval: () => import('@/views/repertory/FreightApproval/CreateFreightApproval'), // 创建运费审批
  viewFreightApproval: () => import('@/views/repertory/FreightApproval/ViewFreightApproval'), // 运费审批详情
  logisticsConfiguration: () => import('@/views/repertory/LogisticsConfiguration'), // 物流配置
  logisticsExpenseBillConfig: () => import('@/views/repertory/LogisticsExpenseBillConfig'), // 仓储物流费用单
  logisticsExpenseBillConfigDetail: () => import('@/views/repertory/LogisticsExpenseBillConfig/Detail'), // 仓储物流费用单详情
  //   仓储物流
  warehouseVarianceConfigList: () => import('@/views/repertory/WarehouseVarianceConfig'),
  expressFeeErrorList: () => import('@/views/repertory/ExpressFeeError/index'),
  expressFeeErrorDetail: () => import('@/views/repertory/ExpressFeeError/Detail'),
  estimateExpressFeeList: () => import('@/views/repertory/EstimateExpressFee/index'),
  estimateExpressFeeDetail: () => import('@/views/repertory/EstimateExpressFee/Detail'),
  logisticsFreightBillConfigList: () => import('@/views/repertory/LogisticsFreightBillConfig/index'),
  logisticsFreightBillConfigDetail: () => import('@/views/repertory/LogisticsFreightBillConfig/Detail'),
  LogisticsSettlementApplicationList: () => import('@/views/repertory/LogisticsSettlementApplication/index'), // 物流仓储费用结算申请列表
  LogisticsSettlementApplicationDetail: () => import('@/views/repertory/LogisticsSettlementApplication/Detail'), // 物流仓储费用结算申请详情
  LogisticsPaymentExecutionList: () => import('@/views/repertory/LogisticsPaymentExecution/index'), // 物流仓储费用付款申请列表
  LogisticsPaymentExecutionDetail: () => import('@/views/repertory/LogisticsPaymentExecution/Detail') // 物流仓储费用付款申请详情

}

export default map
